import { Typography } from "@faire/web/slate/Typography";
import { Medium } from "@faire/web/ui/Typography/Span";
import * as React from "react";

/* eslint-disable @faire/no-dollar-symbol-in-strings */

export const AmexIncentiveBanner: React.FC = () => {
  return (
    <Typography align="center">
      <Medium>Get $100 off</Medium> your first order of $150 or more!
    </Typography>
  );
};
